const kpiTrackerMessages = {
  pageTitles: {
    title: 'KPI Tracker ',
    subTitle: {
      part1: 'Track your KPI from ',
      part2: ' to ',
      part3: ' to plan intervention strategy',
    },
  },
  buttonText: {
    download: 'Download',
    queryData: 'Query Data',
    submit: 'Submit',
  },
  pageContent: {
    title: 'Track your KPI',
    programTitle: 'What is the name of your program ? ',
    dateImplementation: 'What is the date of implementation ?',
    additionalTimeMarkers: 'Additional data markers',
    timeMarkersPlaceholder: 'Data Marker Identifier',
    programLabel: 'Select Program',
    kpiSelection: 'Select your KPIs',
  },
  InternalPage: {
    subTitle: 'Track your ',
  },
};

export default kpiTrackerMessages;
